var fillCart, updateCartTotal, validateRecipientform, updateGratuity, updateMethod, fillPreview;

if (!("ontouchstart" in document.documentElement)) {
    document.documentElement.className += "no-touch";
}

jQuery(function($){
	validateForm = function(form){
		var errors = false;
		$(form).find('.validate:visible').each(function(){
			var value =$(this).val();
			if($(this).next('span.validation-error').length == 0){
				$(this).after('<span class="validation-error"></span');
			}
			$(this).off('focus').on('focus change', function(){
				$(this).removeClass('error');
				$(this).next('span.validation-error').fadeOut(300);
				if($(this).hasClass('radio-required')){
					var name = $(this).attr('name');
					$('input[name="'+name+'"]').removeClass('error');
					$('input[name="'+name+'"]').next('span.validation-error').fadeOut(300);
				}
			});


			if($(this).hasClass('required') && value == ""){
				$(this).addClass('error');
				$(this).next('span.validation-error').html('This field is required.').fadeIn(300);
				errors = true;
			}
			if($(this).hasClass('email')){
				var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;				
				if(!filter.test(value)){
					$(this).addClass('error');
					$(this).next('span.validation-error').html('Please provide a valid email address.').fadeIn(300);
					errors = true;
				}
			}
			if($(this).hasClass('zipcode')){
				if(!(/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value))){
					$(this).addClass('error');
					$(this).next('span.validation-error').html('Please provide a valid zipcode.').fadeIn(300);
					errors = true;
				}
			}
			if($(this).hasClass('phone')){
				phone = $(this).val();
		        phone = phone.replace(/[^0-9]/g,'');
		        if (phone.length != 10){
		            $(this).addClass('error');
					$(this).next('span.validation-error').html('Please provide a valid phone number.').fadeIn(300);
					errors = true;
		        }
		    }
			if($(this).hasClass('radio-required')){
				var name = $(this).attr('name');
				if(typeof($(form).find('input[name="'+name+'"]:checked').val()) == "undefined"){
					$(this).addClass('error');
					$(form).find('input[name="'+name+'"]').last().next('span.validation-error').html('Please select an option.').fadeIn(300);
					errors = true;
				}
			}
			if($(this).hasClass('ccnumber')){ //make sure to include /js/vendor/jquery.creditCardValidator.js
				var result = $(this).validateCreditCard({ accept: ['visa', 'mastercard', 'amex'] })
				if(!result.valid){
					$(this).addClass('error');
					$(this).next('span.validation-error').html('Please provide a valid Credit Card Number.').fadeIn(300);
					errors = true;
				}
			}
		});
		if(errors){
			var topPos = $('.validation-error:visible').first().parent().position().top;
			if(topPos == 0){
				topPos = $('.validation-error:visible').first().parent().parent().position().top;
			}
			$('html,body').animate({scrollTop: topPos - 20}, 200);
			return false;	
		}
		return true;
	}
});


// WEBPACK FOOTER //
// ./resources/assets/js/common.js